import * as React from "react";
import type { SVGProps } from "react";
const SvgHoneymoon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#honeymoon_svg__a)">
      <path d="M9 20a7 7 0 0 1-7-7 7 7 0 0 1 5-6.72 1 1 0 0 1 .56 1.92A5 5 0 0 0 4 13a5 5 0 1 0 9.004-2.998A5 5 0 0 0 10.41 8.2a1 1 0 1 1 .56-1.92 7 7 0 0 1 5 6.72A7 7 0 0 1 9 20" />
      <path d="M15.5 22A6.51 6.51 0 0 1 9 15.5 6.51 6.51 0 0 1 15.5 9a6.51 6.51 0 0 1 6.5 6.5 6.51 6.51 0 0 1-6.5 6.5m0-11a4.51 4.51 0 0 0-4.5 4.5 4.51 4.51 0 0 0 4.5 4.5 4.51 4.51 0 0 0 4.5-4.5 4.51 4.51 0 0 0-4.5-4.5M9 10a1 1 0 0 1-.8-.4L4.6 4.8a1 1 0 0 1 .09-1.31l1.2-1.2A1 1 0 0 1 6.6 2h4.8a1 1 0 0 1 .71.29l1.2 1.2a1 1 0 0 1 .09 1.31L9.8 9.6a1 1 0 0 1-.8.4M6.72 4.29l2.28 3 2.28-3L11 4H7z" />
    </g>
    <defs>
      <clipPath id="honeymoon_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHoneymoon;
